import { inject, Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { normalizeOperator } from '../../../common/functions';
import { InsectaServiceBase } from '../insecta.base.service';
import { ISearchRequest, ISearchResult } from '../insecta.models';

import { MessageService } from 'primeng/api';
import { downloadXlsxDocument } from '../../../common/functions';
import { notifyAndTrackError } from '../../../common/error';
import { AppInsightsService } from '../../app-insights.service';

@Injectable({
  providedIn: `root`
})
export class RequesterDashboardService extends InsectaServiceBase {
  private readonly appInsights = inject(AppInsightsService);
  private readonly msgService = inject(MessageService);

  public getCalendar(request: ISearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    return this.post<ISearchResult>(`/dashboard/requester/calendar`, `v1`, request);
  }
  public getTable(request: ISearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    return this.post<ISearchResult>(`/dashboard/requester/table`, `v1`, request);
  }

  public getReceiveCount(request: ISearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    return this.post<ISearchResult>(`/dashboard/requester/receive/count`, `v1`, request);
  }
  public async getReceiveExport(request: ISearchRequest): Promise<void> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    await firstValueFrom(this.fetchBlob(`/dashboard/requester/receive/export`, `v1`, request))
      .then((response) => {
        const filename = `ReceiveInstancesExport-${new Date().toISOString().slice(0, 10)}.xlsx`;
        downloadXlsxDocument(response, filename);
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'ExportService', action: 'GetInstancesXlsx' });
      });
  }
  public getReceiveTable(request: ISearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => filter.values.forEach((value) => (value.operator = normalizeOperator(value.operator))));
    return this.post<ISearchResult>(`/dashboard/requester/receive/table`, `v1`, request);
  }
}
